var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('stat-card',{attrs:{"title":"Received Subtotal","color":"teal accent-1","amount":_vm.total,"icon":"group","sub_title":""}}),_c('stat-card',{attrs:{"title":"GST on Received","color":"teal accent-2","amount":_vm.gst,"icon":"group","sub_title":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }